<template>
  <fragment>
    <Header :scroll="scroll" :open-appointment-window="openAppointmentWindow" />
    <About id="about" />
    <Specialities id="specialities" />
    <Card id="card" />
    <Partnerships id="partnerships" />
    <Contacts id="contacts" />
    <Footer />
    <Appointment ref="appointment" :snackbar="snackbar" />
  </fragment>
</template>

<script>
import Header from "../components/home/Header.vue";
import About from "../components/home/About.vue";
import Specialities from "../components/home/Specialities.vue";
import Partnerships from "../components/home/Partnerships.vue";
import Card from "../components/home/Card.vue";
import Contacts from "../components/home/Contacts.vue";
import Appointment from "../components/home/Appointment.vue";

export default {
  name: "Home",

  components: {
    Header,
    About,
    Specialities,
    Partnerships,
    Card,
    Contacts,
    Appointment,
  },

  props: {
    scroll: {
      type: Number,
      required: true,
    },
    snackbar: {
      type: Object,
      required: true,
    },
  },

  data: () => ({}),

  methods: {
    openAppointmentWindow() {
      // this.$refs.appointment.openDialog();
    },
  },
};
</script>
